import { orderServiceApi } from "../../apis/orderServiceApi";
import { ORDER_API_TAGS } from "../../app.constants";
import type { IPublicCheckoutDto } from "./order.types";

export const orderService = orderServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    publicCheckout: builder.mutation<any, IPublicCheckoutDto>({
      query: (body) => ({
        url: "/me/checkout/for-order",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: ORDER_API_TAGS.ORDER, id: "PUBLIC_CHECKOUT" }],
    }),
  }),
});

export const { usePublicCheckoutMutation } = orderService;
